// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhn_a bhn_x bhn_j bhn_u bhn_bc bhn_ql bhn_vv"};